import { render, staticRenderFns } from "./trending.vue?vue&type=template&id=0008b1e6"
import script from "./trending.vue?vue&type=script&lang=js"
export * from "./trending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports